module.exports = __webpack_public_path__ + "img/hj-logo.13a3bfa8.jpg";